import React from 'react';

const SSOPageConfig = {
    routes: [
        {
            path: '/sso/connection',
            exact: true,
            component: React.lazy(() => import('./SSOPage'))
        }
    ]
};

export default SSOPageConfig;